import { useMutation } from '@tanstack/react-query'

import { productUpdatesApi } from '../..'
import { SuccessResponse } from '../../productUpdateTypes'
import { AcknowledgementResponse } from './acknowledgeUpdate.types'

export const ACKNOWLEDGE_MATERIAL_MUTATION_KEY = 'ACKNOWLEDGE_MATERIAL'

export const acknowledgeMaterial = async (materialId: string) => {
  const response = await productUpdatesApi.get<
    SuccessResponse<AcknowledgementResponse>
  >(`/me/${materialId}/acknowledgement`)
  return response?.data?.data
}

export const useAcknowledgeMaterialMutation = () => {
  return useMutation({
    mutationKey: [ACKNOWLEDGE_MATERIAL_MUTATION_KEY],
    mutationFn: acknowledgeMaterial
  })
}
